import { MapPage } from './MapPage'

export function HomePage() {
  return <MapPage />
}
